import React from 'react';
import { AsyncPlayButton } from 'modules/audio';
import classes from './AudioPreviewPlaceholder.module.scss';

export default function AudioPreviewPlaceholder({
  title = 'Invited',
  description = 'Waiting for submission',
}) {
  return (
    <div>
      <AsyncPlayButton
        disabled
        containerClassName={classes.buttonContainer}
        className={classes.button}
      />
      <div className={classes.info}>
        <div className={classes.title}>{title}</div>
        <div className={classes.description}>{description}</div>
      </div>
    </div>
  );
}
